import { Mensagem } from './mensagem'

export enum TipoArea {
    SETOR = "SETOR",
    CENTRO_CUSTO = "CENTRO_CUSTO"
}

export interface Area {
    idArea: number,
    codArea: number,
    idAdministradores: number[],
    idMembros: number[],
    nome: string,
    tipo: TipoArea,
    hashImagem: string,
    nomeTipo: string,
    mensagens: Mensagem[]
}


// WEBPACK FOOTER //
// ./src/models/area.ts